import { AutoCompleteLabel } from 'types';

export enum OptionsQuestionStepFormFieldsNames {
  Name = 'name',
  Input = 'input',
  Variable = 'variable',
  Answers = 'answers',
  RemoveAnswerOptions = 'removeAnswerOptions',
  OptionFullWidth = 'optionFullWidth',
  HideOptions = 'hideOptions',
  ValidationMessage = 'validationMessage',
  NodeId = 'nodeId',
  Labels = 'labels',
}

export interface OptionsQuestionStepFormFields {
  [OptionsQuestionStepFormFieldsNames.Name]: string;
  [OptionsQuestionStepFormFieldsNames.Input]: string;
  [OptionsQuestionStepFormFieldsNames.Variable]?: string;
  [OptionsQuestionStepFormFieldsNames.NodeId]: string;
  [OptionsQuestionStepFormFieldsNames.Answers]: OptionsQuestionStepFormFieldsOptions[];
  [OptionsQuestionStepFormFieldsNames.RemoveAnswerOptions]?: boolean;
  [OptionsQuestionStepFormFieldsNames.OptionFullWidth]?: boolean;
  [OptionsQuestionStepFormFieldsNames.HideOptions]?: boolean;
  [OptionsQuestionStepFormFieldsNames.ValidationMessage]?: string;
  [OptionsQuestionStepFormFieldsNames.Labels]?: AutoCompleteLabel[];
}

export enum OptionsQuestionStepFormFieldsOptionsNames {
  Name = 'name',
  Answer = 'option',
  NodeId = 'nodeId',
  Labels = 'labels',
  Value = 'value',
}

export interface OptionsQuestionStepFormFieldsOptions {
  [OptionsQuestionStepFormFieldsOptionsNames.Name]: string;
  [OptionsQuestionStepFormFieldsOptionsNames.Answer]: string;
  [OptionsQuestionStepFormFieldsOptionsNames.NodeId]: string;
  [OptionsQuestionStepFormFieldsOptionsNames.Labels]?: string[];
  [OptionsQuestionStepFormFieldsOptionsNames.Value]?: string;
}
